import Button from '../ui_components/button/button';
import {
  Modal,
  ModalActions as ModalActionsE,
  ModalContent,
  ModalHeader as ModalHeaderE,
} from '../ui_components/modal';
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '../theme';

const noop = () => {
  /* ignore */
};

interface ExportConfirmationModalProps {
  uiActive: boolean;
  uiOnCancel(): void;
  uiOnContinue(): void;
  selectedNumber: number;
  ordersWithoutWO: number;
}

const ClientsImportContent = styled(ModalContent)`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  color: ${theme.colors.grayRGBA};
`;

const StyledModal = styled(Modal)`
  max-width: 500px;
  border-radius: 0.5rem;
  border: solid ${theme.colors.grayRGBA} 1px;
  ${breakpoints.down(
    'sm',
    css`
      max-width: 90%;
    `
  )};
`;

const ModalHeader = styled(ModalHeaderE)`
  border-bottom: none;
  padding-bottom: 0.25rem;
  font-size: 18px;
  font-weight: 500;
`;

const ModalActions = styled(ModalActionsE)`
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  justify-content: flex-end;
  padding: 0.7rem 1rem;
`;

const BasicButton = styled(Button)`
  box-shadow: none;
  border: 1px solid #c6c6c6;
  border-radius: 0.5em;
  display: block;
`;

const CancelButton = styled(Button)`
  box-shadow: none !important;
`;

const ConfirmButton = styled(BasicButton)`
  border-radius: 5px;
  box-shadow: none;
  line-height: 0.6rem;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e0e0e0;
  }

  &:disabled {
    background-color: #c6c6c6;
    color: #888888;
    cursor: not-allowed;

    &:hover {
      background-color: #c6c6c6;
    }
  }

  margin-left: ${(props) => (props.className === 'pop-up' ? 'auto' : 'initial')};
`;

const ExportConfirmationModal: React.FC<ExportConfirmationModalProps> = (props) => {
  const { uiActive, uiOnCancel, uiOnContinue, selectedNumber, ordersWithoutWO } = props;
  const readyOrders = selectedNumber - ordersWithoutWO;
  return (
    <StyledModal
      uiActive={uiActive}
      uiDefaultSizes={false}
      uiOnRequestClose={noop}
      uiCloseOnOutsideClick={true}
      uiCloseOnEsc={true}
    >
      <ModalHeader>Some Items Aren’t Ready to Export</ModalHeader>

      <ClientsImportContent>
        Your selection includes {ordersWithoutWO} incomplete items, which still need calculation and
        won’t be exported.
        <br />
        {readyOrders > 0 ? (
          `We’ll export ${readyOrders} of ${readyOrders + ordersWithoutWO} items.`
        ) : (
          <strong>There are no complete items to export.</strong>
        )}
      </ClientsImportContent>
      <ModalActions>
        <CancelButton className="cancel_btn" id="cancel-export" uiColor="primary" onClick={uiOnCancel}>
          Cancel
        </CancelButton>
        <ConfirmButton
          disabled={readyOrders === 0 ? true : false}
          id="confirm"
          uiColor="primary"
          onClick={uiOnContinue}
        >
          Export
        </ConfirmButton>
      </ModalActions>
    </StyledModal>
  );
};

ExportConfirmationModal.defaultProps = {};

export default ExportConfirmationModal;
